import { useAudienceContext } from '../../context';
import { ErrorEmptyState } from './ErrorEmptyState';
import { ListTypeEmptyState } from './ListTypeEmptyState';
import { SearchEmptyState } from './SearchEmptyState';

export const TableEmptyState = () => {
  const { searchText, errorMessage } = useAudienceContext();

  let EmptyState;
  if (errorMessage) {
    EmptyState = ErrorEmptyState;
  } else if (searchText) {
    EmptyState = SearchEmptyState;
  } else {
    EmptyState = ListTypeEmptyState;
  }

  return <EmptyState />;
};
